import { AbsoluteFill, useCurrentFrame } from "remotion";
import { COLORS, FONTS, LOGO, CTA_GOLD, BADGE_DARK, GLOBS } from "./theme";
import { Background } from "./Background";

export const InstagramStory: React.FC<{
  headline: string;
  subheadline: string;
  cta: string;
}> = ({ headline, subheadline, cta }) => {
  const frame = useCurrentFrame();
  const opacity = Math.min(frame / 15, 1);

  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(160deg, ${COLORS.dark} 0%, ${COLORS.darkAlt} 100%)`,
        fontFamily: FONTS.sans,
        opacity,
      }}
    >
      <Background theme="dark" />

      <div
        style={{
          position: "absolute",
          top: -150,
          right: -100,
          width: 500,
          height: 500,
          borderRadius: "50%",
          background: GLOBS.goldGlow,
          filter: "blur(80px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -200,
          left: -100,
          width: 600,
          height: 600,
          borderRadius: "50%",
          background: GLOBS.darkGlow,
          filter: "blur(100px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "30%",
          left: -80,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: GLOBS.goldSmall,
          filter: "blur(60px)",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 120,
          right: 60,
          width: 280,
          height: 280,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.12)",
          opacity: 0.5,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 150,
          right: 90,
          width: 220,
          height: 220,
          borderRadius: "50%",
          border: "0.5px solid rgba(197,160,89,0.08)",
          opacity: 0.3,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 100,
          left: 40,
          width: 160,
          height: 160,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.06)",
          opacity: 0.3,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 60,
          left: 60,
          display: "flex",
          alignItems: "center",
          gap: 10,
          zIndex: 2,
        }}
      >
        <div style={LOGO}>E</div>
        <span
          style={{
            fontSize: 13,
            color: COLORS.textMuted,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          @santoro.analista
        </span>
      </div>

      <div
        style={{
          position: "absolute",
          top: 130,
          left: 60,
          zIndex: 2,
        }}
      >
        <span style={BADGE_DARK}>O CORPO EXPLICA</span>
      </div>

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 60,
          transform: "translateY(-60%)",
          zIndex: 2,
        }}
      >
        <div
          style={{
            fontFamily: FONTS.serif,
            fontSize: 96,
            fontWeight: 400,
            color: COLORS.white,
            lineHeight: 1.05,
            marginBottom: 20,
            letterSpacing: "-0.03em",
            textShadow: "0 4px 20px rgba(0,0,0,0.4)",
          }}
        >
          {headline}
        </div>

        <div
          style={{
            fontSize: 22,
            color: COLORS.gold,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            marginBottom: 60,
            fontWeight: 300,
            textShadow: "0 2px 10px rgba(197,160,89,0.2)",
          }}
        >
          {subheadline}
        </div>

        <div style={CTA_GOLD}>{cta}</div>
      </div>
    </AbsoluteFill>
  );
};
